import { z } from 'zod';
import {
  createDocumentMailDraftSchema,
  MAIL_DRAFT_MAX_ATTACHMENT_BYTES,
  mailDraftResultSchema,
  mailDraftSettingsSchema,
  mailTextToHtml,
  saveMailDraftSettingsSchema,
} from '../documents/mail-draft';

/**
 * Angebot als Mail-Entwurf (ADR 0113). Seit dem Nachtrag zu ADR 0113 liegt der
 * allgemeine Teil (Einrichtung, Graph-Nachricht, Grenzen) in `documents/mail-draft.ts`
 * und gilt auch für Verkauf und Einkauf; hier bleiben die bisherigen Namen der
 * Angebotskalkulation als Aliase, damit nichts bricht.
 */

/** Graph nimmt Anhänge in einem JSON-Aufruf bis ~4 MB (Base64 inklusive) — mit Luft. */
export const OFFER_MAIL_MAX_ATTACHMENT_BYTES = MAIL_DRAFT_MAX_ATTACHMENT_BYTES;

export const quoteCalcMailSettingsSchema = mailDraftSettingsSchema;
export type QuoteCalcMailSettings = z.infer<typeof quoteCalcMailSettingsSchema>;

export const saveQuoteCalcMailSettingsSchema = saveMailDraftSettingsSchema;
export type SaveQuoteCalcMailSettingsInput = z.infer<typeof saveQuoteCalcMailSettingsSchema>;

export const createQuoteOfferMailDraftSchema = createDocumentMailDraftSchema.extend({
  language: z.enum(['de', 'en']).optional(),
});
export type CreateQuoteOfferMailDraftInput = z.infer<typeof createQuoteOfferMailDraftSchema>;

export const quoteOfferMailDraftResultSchema = mailDraftResultSchema;
export type QuoteOfferMailDraftResult = z.infer<typeof quoteOfferMailDraftResultSchema>;

/** Klartext → einfaches HTML für Outlook (Absätze, Zeilenumbrüche). */
export const offerMailTextToHtml = mailTextToHtml;

/** Vorschlag für Betreff und Text in der Sprache des Angebots. */
export function defaultOfferMail(
  calc: { displayNumber: string; name: string },
  language: 'de' | 'en',
  senderName: string,
): { subject: string; text: string } {
  if (language === 'en') {
    return {
      subject: `Offer ${calc.displayNumber} – ${calc.name}`,
      text: `Dear Sir or Madam,\n\nplease find attached our offer ${calc.displayNumber} for ${calc.name}.\n\nWe look forward to hearing from you.\n\nKind regards\n${senderName}`,
    };
  }
  return {
    subject: `Angebot ${calc.displayNumber} – ${calc.name}`,
    text: `Sehr geehrte Damen und Herren,\n\nanbei erhalten Sie unser Angebot ${calc.displayNumber} für ${calc.name}.\n\nFür Rückfragen stehen wir gerne zur Verfügung.\n\nMit freundlichen Grüßen\n${senderName}`,
  };
}
